const angularModule = angular.module('com.comtrade.azureCloud.backup.components', [
]);

angularModule.directive('translate', require('./translateDirective/translate.directive'));
angularModule.directive('aceEditor', require('./aceEditor/aceEditor.directive'));
angularModule.component('expireDialog', require('./expireDialog/expireDialog.component'));
angularModule.component('backupsDetailsView', require('./backupsDetailsView/backupsDetailsView.component'));


module.exports = angularModule;



// WEBPACK FOOTER //
// ./src/azurebackup/components/components.module.js